import { useState, useCallback } from 'react';

export type OutboundNumberSelectorView = 'active-conversations' | 'all-numbers' | 'all-locations';

type InitializeViewArgs = {
  hasActiveConversation: boolean;
  isMultiLocation: boolean;
  isNewThreadCreation: boolean;
  hasEnabledOutboundPhones: boolean;
};

export const useOutboundNumberSelectorView = () => {
  const [view, setView] = useState<OutboundNumberSelectorView>('active-conversations');

  /**
   * Initialize the view based on context:
   *
   * For NEW thread creation (isNewThreadCreation = true):
   * - If has enabled phones → Start at 'all-numbers' (or 'all-locations' for multi-loc)
   * - If no enabled phones but has recent → Start at 'all-numbers' (shows empty state)
   *
   * For EXISTING thread (isNewThreadCreation = false):
   * - If has recent activity → Start at 'active-conversations'
   * - Otherwise → Start at 'all-numbers' or 'all-locations'
   */
  const initializeView = useCallback(
    ({ hasActiveConversation, isMultiLocation, isNewThreadCreation, hasEnabledOutboundPhones }: InitializeViewArgs) => {
      if (isNewThreadCreation) {
        if (isMultiLocation && hasEnabledOutboundPhones) {
          setView('all-locations');
        } else {
          setView('all-numbers');
        }
        return;
      }

      if (hasActiveConversation) {
        setView('active-conversations');
      } else if (isMultiLocation) {
        setView('all-locations');
      } else {
        setView('all-numbers');
      }
    },
    []
  );

  return {
    initializeView,
    setView,
    view,
  };
};
